import api from "utils/api";

// 공지사항 목록 조회 (로그인 필수)
// 정렬은 BE가 처리 (중요 공지 우선 → 게시일 최신순). FE 재정렬 불필요.
export const getNotices = async ({ page = 1, pageSize = 20 } = {}) => {
    const res = await api.get(`/buccl_main/api/v1/notices/`, {
        params: { page, page_size: pageSize },
    });
    return res.data;
};

// 공지사항 상세 조회 (로그인 필수)
export const getNoticeDetail = async (id) => {
    const res = await api.get(`/buccl_main/api/v1/notices/${id}/`);
    return res.data;
};
